export const MARKETING = 'MARKETING';
export const SALES = 'SALES';
export const SERVICE = 'SERVICE';
export const CORE = 'CORE';